<script lang="ts" setup>
const { html } = defineProps<{ html: string }>()

const { $parseStringToDocument } = useNuxtApp()

const content = computed(() => $parseStringToDocument(html, ['sanitize-law-footnotes']))
</script>

<template>
  <div :class="lawVariants.footnote.base()" v-html="content.body.innerHTML" />
</template>
